import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

// Seguros y siniestros comparten estructura; solo cambia el sufijo (Seg / Sin)
function CrearConsultas(sufijo) {

    const GET = `
        query get($filtro: InputGetCatEstadoSeguimiento){
            getCatEstadoSeguimiento${sufijo}(filtro: $filtro){
                estadoID
                nombre
                color
                esFinal
                orden
            }
        }`;

    const TABLA = `
        query filtro($filtro: InputFiltroCatEstadoSeguimiento){
            filterCatEstadoSeguimiento${sufijo}(filtro: $filtro){
                listado{
                    estadoID
                    nombre
                    color
                    esFinal
                    esFinalTexto
                    orden
                }
                registros
                paginas
            }
        }`;

    const get = async (filtro, token) => {
        try {
            let resultado = await FetchAPI.graphql({
                token,
                variables: { filtro },
                url: urlServidor,
                query: GET
            });
            return resultado[`getCatEstadoSeguimiento${sufijo}`];
        } catch ({ message }) { throw new Error(message); }
    };

    const tabla = async (variables, token) => {
        try {
            let resultado = await FetchAPI.graphql({
                token,
                variables,
                url: urlServidor,
                query: TABLA
            });
            return resultado[`filterCatEstadoSeguimiento${sufijo}`];
        } catch ({ message }) { throw new Error(message); }
    };

    return { get, tabla };
}

const consultasSeg = CrearConsultas("Seg");
const consultasSin = CrearConsultas("Sin");

export const getEstadoSeguimientoSeg = consultasSeg.get;
export const tablaEstadoSeguimientoSeg = consultasSeg.tabla;
export const getEstadoSeguimientoSin = consultasSin.get;
export const tablaEstadoSeguimientoSin = consultasSin.tabla;
